<template>
  <div class="ikomsk">
    {{ String(addCommas(item.ikomsk)).replace(",00", "") }}
    <!-- <v-icon right small @click="() => showUslRab(item.uslrab)">info</v-icon> -->

    <br />
    <span class="procent">{{
      procent(item.ikomsk, calc.summ, calc.days, yearProcent)
    }}</span>
  </div>
</template>
<script>

export default {
  name: "",
  components: {},
  data: () => ({}),
  props: {
    item: { type: Object },
    calc: { type: Object },
    yearProcent: { type: Boolean },
  },
  methods: {
    showUslRab(uslrab) {
      this.$emit('dialog',{dialog: true, dialogText: uslrab})
    },
  },
  created() {},
  mounted() {},
  watch: {},
};
</script>
<style lang="sass" scoped></style>
